import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Eye } from 'lucide-react';
interface LiveViewersProps {
  baseCount: number;
  label: string;
  note: string;
}
export function LiveViewers({
  baseCount,
  label,
  note
}: LiveViewersProps) {
  const [count, setCount] = useState(baseCount);
  const [mounted, setMounted] = useState(false);
  const [clearOfHero, setClearOfHero] = useState(false);
  useEffect(() => {
    const showTimer = window.setTimeout(() => setMounted(true), 1200);
    return () => window.clearTimeout(showTimer);
  }, []);

  // En móvil el titular ocupa todo el ancho: el aviso entra al salir del hero.
  useEffect(() => {
    const update = () => {
      setClearOfHero(window.innerWidth >= 640 || window.scrollY > 220);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  useEffect(() => {
    const id = window.setInterval(() => {
      setCount(current => {
        const drift = Math.floor(Math.random() * 7) - 3;
        const next = current + drift;
        const min = Math.round(baseCount * 0.78);
        const max = Math.round(baseCount * 1.24);
        return Math.min(max, Math.max(min, next));
      });
    }, 3800);
    return () => window.clearInterval(id);
  }, [baseCount]);
  return <AnimatePresence data-id="element-145" data-mp="1ziagoic5tsm2">
      {mounted && clearOfHero && <motion.aside initial={{
      opacity: 0,
      x: 24
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: 24
    }} transition={{
      duration: 0.45,
      ease: 'easeOut'
    }} aria-live="polite" className="fixed right-2.5 top-[52px] z-40 flex max-w-[calc(100vw-1.25rem)] items-center gap-2.5 rounded-sm border border-white/10 bg-carbon/95 px-3 py-2 shadow-[0_14px_34px_rgba(0,0,0,0.55)] backdrop-blur-sm sm:right-5 sm:top-[68px] sm:gap-3 sm:px-3.5 sm:py-2.5" data-id="element-146" data-mp="24dfxx3umaj3t">
          <span className="relative flex h-5 w-5 shrink-0 items-center justify-center sm:h-6 sm:w-6" data-id="element-147" data-mp="1mctwyxog6sn0">
            <motion.span aria-hidden="true" className="absolute inset-0 rounded-full bg-gold/25" animate={{
          scale: [1, 1.5],
          opacity: [0.5, 0]
        }} transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: 'easeOut'
        }} data-id="element-148" data-mp="1hflgr2mv0yoe" />
            <Eye aria-hidden="true" className="relative h-4 w-4 text-gold-soft" data-id="element-149" data-mp="259v8708lhoze" />
          </span>

          <div className="leading-tight" data-id="element-150" data-mp="20btnkavithlt">
            <p className="font-mono text-[10px] tracking-[0.04em] text-ivory sm:text-[11px]" data-id="element-151" data-mp="2f199ndk3wyv6">
              <AnimatePresence mode="popLayout" initial={false} data-id="element-152" data-mp="2a265dvbyawo9">
                <motion.span key={count} initial={{
              opacity: 0,
              y: -8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 8
            }} transition={{
              duration: 0.25
            }} className="inline-block font-semibold text-gold-soft" data-id="element-153" data-mp="2a2y2jal752gn">
                  {count}
                </motion.span>
              </AnimatePresence>{' '}
              {label}
            </p>
            <p className="mt-0.5 hidden font-mono text-[8.5px] uppercase tracking-[0.12em] text-ash/70 sm:block" data-id="element-154" data-mp="2tmwoqkbgdd76">
              {note}
            </p>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}